import { Reveal, Overline } from "./Reveal";
import { FAQ } from "../../lib/content";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger
} from "../ui/accordion";

export const Faq = () => (
  <section id="faq" className="relative py-24 md:py-36 scroll-mt-20" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 lg:px-10">
      <Reveal className="text-center">
        <Overline>Perguntas Frequentes</Overline>
        <h2 className="mt-6 font-display text-4xl md:text-5xl font-extrabold tracking-tight">
          As dúvidas que recebemos antes de toda grande parceria
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-12">
        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-semibold text-white hover:text-bf-yellow hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
